export enum LoginStatus {
  LoggingIn,
  LoggedIn,
  LoggedOut,
}



// WEBPACK FOOTER //
// ./src/infrastructure/LoginStatus.ts